<div class="col-sm-12" style="margin-bottom: 10px;">
  <label class="control-label">{{ 'common.label' | translate | titlecase }}</label
  ><br />
  <input type="text" class="form-control" [(ngModel)]="fileUploadSettings.LabelText" />
</div>
<div class="col-sm-12">
  <label class="control-label">{{ 'forms.form-builder.upload-file.web-content-type' | translate | titlecase }}</label>
  <select class="form-control" [(ngModel)]="fileUploadSettings.WebContentTypeId">
    <option value="0">{{ 'common.select-one' | translate | titlecase }}</option>
    <option *ngFor="let webContentType of webContentTypes" [value]="webContentType.ContentTypeID">{{ webContentType.Descr }}</option>
  </select>
</div>
